<template
	><div style="padding-top:-2px;margin-top:-2px;">
		<v-label
			><b>{{ label }}</b></v-label
		>
		<s-select-generic
			class="text"
			itemvalue="VrtID"
			:disabled="disabled"
			:value="value"
			id="VrtID"
			itemtext="VrtDescription"
			:return-object="returnObject"
			@input="input($event)"
			:config="config"
			@change="change($event)"
			:full="full"
			:text="text"
			:clearable="clearable"
			:noDefault="noDefault"
			:readonly="readonly"
			@updateData="$emit('getDataInitial', $event)"
		>
		</s-select-generic>
	</div>
</template>

<script>
	import _sService from "@/services/Technicalassistance/HarvestSchedule.js";
	export default {
		components: {},
		props: {
			disabled: {
				type: Boolean,
				default: false,
			},
			clearable: {
				type: Boolean,
				default: false,
			},
			value: null,
			text: { type: String, default: "" },
			label: {
				type: String,
				default: "",
			},
			returnObject: {
				type: Boolean,
				default: false,
			},
			cultiveID: {
				type: Number,
				default: 0,
			},
			noDefault: {
				type: Boolean,
				default: false,
			},
			full: {
				type: Boolean,
				default: false,
			},
			readonly: {
				type: Boolean,
				default: false,
			},
		},
		watch: {
			value(value) {
				this.item = value;
			},
			cultiveID() {
				this.config.params.TypeCultive =
					this.cultiveID == null ? 0 : this.cultiveID;
			},
		},
		methods: {
			input(val) {
				this.$emit("input", val);
			},
			change(val) {
				this.$emit("change", val);
			}
		},
		data: () => ({
			item: 0,
			val: "",
			items: [],
			config: {},
		}),

		created() {
			this.config = {
				url: _sService.GetUrllistVariaty(),
				title: this.label,
				params: {
					TypeCultive: this.cultiveID == null ? 0 : this.cultiveID,
					search: "",
					requestID: this.$fun.getUserID(),
				},
			};
			/* ==0? 0 :this.cultiveID  */
		},
	};
</script>
